import React, { useState } from 'react';
import '../dropdown/Hatchback.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaArrowRight } from 'react-icons/fa';
import minis from '../assets/minic.webp';
import xuv3xoCng from '../assets/3xocng.png';
import tiago from '../assets/newtiago.webp';
import ioniq from '../assets/ioniq.png';
import taigun from '../assets/taigun.png'
import ebella from '../assets/ebella.png';
import cla from '../assets/cla.png'
import m440i from '../assets/m440i.png';
import Pagination from './Pagination';
import SidebarExpertReviews from './SidebarExpertReviews';
import SidebarElectricVehicles from './SidebarElectricVehicles';

const Hatchback = () => {
 const hatchbacks = [
    {
      id: 1,
      title: "Mini Countryman C",
      price: "₹46.00 - ₹52.00 Lakh (Est.)",
      engine: "1.5L Turbo Petrol",
      description: "Launching in mid-June 2026, this premium hot-hatch upgrade brings racetrack-inspired John Cooper Works (JCW) styling to the open-top Cooper S. Featuring a fully digital circular OLED display, Go-Kart driving modes, and a quick-folding fabric roof, it targets luxury buyers looking for uncompromised performance.",
      image: minis,
      link: "https://www.mini.in/en_IN/home/range/mini-countryman-c.html",
      date: "June 5, 2026",
      segment: "Premium Hatchback"
    },
  {
  id: 2,
  title: "Tata Tiago (2026 Facelift)",
  price: "₹4.69 - ₹8.55 Lakh",
  engine: "1.2L Revotron Petrol / iCNG (86 PS)",
  description: "Tata Motors rolls out a major generational update for its popular city car. The refreshed hatchback receives a sharp, modern styling overhaul, upgraded cabin features, and Tata's latest safety dome technology. Key additions include six standard airbags, dual wireless phone charging, a larger infotainment screen, and a segment-first 360-degree camera with blind-spot monitoring.",
  image: tiago,
  link: "https://cars.tatamotors.com/tiago",
  date: "June 5, 2026",
  segment: "Hatchback"
},
   {
  id: 3,
  title: "Mahindra XUV 3XO CNG Likely To Launch In Late 2026",
  price: "Expected ₹9.00 - ₹12.00 Lakh",
  engine: "1.2L MPFi Turbo Petrol with CNG",
  description: "Mahindra is reportedly preparing to launch a CNG-powered version of the popular XUV 3XO compact SUV by late 2026 or early 2027. The upcoming model is expected to use the 111 hp 1.2-litre MPFi turbo-petrol engine paired with a factory-fitted CNG kit. It will rival the Tata Nexon iCNG and Maruti Suzuki Brezza CNG while retaining premium features such as dual 10.25-inch displays, panoramic sunroof, Level-2 ADAS, six airbags, and a 360-degree camera.",
  image: xuv3xoCng,
  link: "https://auto.ndtv.com/",
  date: "June 5, 2026",
  segment: "Compact SUV (CNG)"
},
    {
      id: 4,
      title: "Hyundai Ioniq 5 Facelift",
      price: "₹55.70 Lakh (Introductory)",
      engine: "84 kWh Battery (Rear-Wheel Drive)",
      description: "Though styled like a futuristic mega-hatchback, this premium EV gets a massive battery capacity upgrade from 72.6 kWh to 84 kWh, boosting the range to an incredible 690 km. The refresh also brings redesigned bumpers, an illuminated Morse-code steering wheel, and advanced parking collision-avoidance technology.",
      image: ioniq,
      link: "https://www.hyundai.com/in/ioniq5",
      date: "May 28, 2026",
      segment: "Premium EV Hatchback"
    },
    {
      id: 5,
      title: "Volkswagen Taigun (2026 Facelift)",
      price: "₹11.00 - ₹19.30 Lakh",
      engine: "1.0L TSI / 1.5L TSI Turbo Petrol",
      description: "The Taigun gets its first proper design overhaul in India. The major highlight is the introduction of a brand-new 8-speed torque converter automatic gearbox for the 1.0L engine. Visual updates include a modern connected LED headlight strip, a glowing rear VW logo, and a significantly quieter, heavily-insulated cabin.",
      image: taigun,
      link: "https://www.volkswagen.co.in/en/models/taigun.html",
      date: "April 09, 2026",
      segment: "Mid-Size SUV"
    },
    {
      id: 6,
      title: "Toyota Urban Cruiser Ebella",
      price: "₹18.00 - ₹23.00 Lakh (Est.)",
      engine: "49 kWh / 61 kWh Battery Pack",
      description: "Toyota's very first dedicated mass-market electric vehicle for India has officially debuted. Offered in E1, E2, and E3 trims, this electric SUV claims a driving range of up to 543 km on a single charge. It comes packed with a fixed panoramic glass roof, ventilated front seats, and an advanced Level 2 ADAS suite.",
      image: ebella,
      link: "https://www.toyotalandcruiser.in/",
      date: "April 15, 2026",
      segment: "Electric SUV"
    },
    {
      id: 7,
      title: "Mercedes-Benz CLA Electric",
      price: "₹55.00 - ₹64.00 Lakh",
      engine: "58 kWh / 85 kWh Battery Pack",
      description: "Marking a massive leap forward for entry-level luxury EVs, the new CLA Electric is built on the premium MMA modular platform. Boasting a world-class aerodynamic drag coefficient of just 0.21 Cd, the high-spec variant offers an astonishing WLTP-certified range of up to 792 km, combined with the next-gen 14-inch MB.OS display.",
      image: cla,
      link: "https://www.mercedes-benz.co.in/",
      date: "April 24, 2026",
      segment: "Luxury EV Sedan"
    },
    {
      id: 8,
      title: "BMW M440i Convertible",
      price: "₹1.09 Crore",
      engine: "3.0L In-Line 6 Turbo (374 PS)",
      description: "For elite open-top performance enthusiasts, BMW launched the M440i Convertible in India. Housing a monstrous 3-litre twin-scroll turbo inline-six engine, it delivers racetrack-derived power, a classic quick-retracting fabric soft-top, and a state-of-the-art curved digital cockpit.",
      image: m440i,
      link: "https://www.bmw.in/",
      date: "April 29, 2026",
      segment: "Luxury Convertible"
    }
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // Reduced for a more spacious editorial rhythm

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = hatchbacks.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(hatchbacks.length / itemsPerPage);

  return (
    <div className="editorial-view-container">
      {/* Editorial Header */}
      <header className="editorial-hero">
        <div className="hero-meta-tag">Exclusive Briefings</div>
        <h1 className="hero-title">New Launches & Deep Dives</h1>
        <p className="hero-sub">The ultimate directory of freshly debuted vehicles on Indian roads.</p>
        <div className="editorial-divider"></div>
      </header>

      <div className="editorial-grid">
        {/* Main Feed */}
        <main className="editorial-feed">
          {currentItems.map((car) => (
            <article className="premium-magazine-row" key={car.id}>
              {/* Left Side: Dynamic Image Canvas */}
              <div className="editorial-canvas">
                <span className="editorial-badge">{car.segment}</span>
                <img src={car.image} alt={car.title} className="editorial-car-img" />
              </div>

              {/* Right Side: Editorial Content */}
              <div className="editorial-text-panel">
                <div className="editorial-card-header">
                  <span className="editorial-date">{car.date}</span>
                </div>
                
                <h3 className="editorial-car-title">{car.title}</h3>
                
                {/* Tech Specs Micro-Grid */}
                <div className="tech-specs-strip">
                  <div className="spec-unit">
                    <span className="spec-label">EST. STARTING PRICE</span>
                    <span className="spec-value">{car.price}</span>
                  </div>
                  <div className="spec-unit">
                    <span className="spec-label">ENGINE SPEC</span>
                    <span className="spec-value">{car.engine}</span>
                  </div>
                </div>

                <p className="editorial-car-desc">{car.description}</p>
                
                <div className="editorial-card-footer">
                  <a href={car.link} target="_blank" rel="noopener noreferrer" className="magazine-action-btn">
                    Read Full Review <FaArrowRight className="arrow-icon" />
                  </a>
                  
                  <div className="editorial-socials">
                    <a href="https://facebook.com" aria-label="Share on Facebook" className="social-pill"><FaFacebookF /></a>
                    <a href="https://twitter.com" aria-label="Share on Twitter" className="social-pill"><FaTwitter /></a>
                    <a href="https://linkedin.com" aria-label="Share on LinkedIn" className="social-pill"><FaLinkedinIn /></a>
                  </div>
                </div>
              </div>
            </article>
          ))}
          
          <div className="editorial-pagination">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </main>

        {/* Sidebar */}
        <aside className="editorial-sidebar">
          <SidebarExpertReviews />
          <SidebarElectricVehicles />
        </aside>
      </div>
    </div>
  );
};

export default Hatchback;